import { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import AgTechPopUpOnHoverContainer from "../../../../../Portals/Popups/AgTechPopUpOnHoverContainer";
import AgTechSideNavigationMenuItem, { AgTechSideNavigationMenuItemProps } from "./AgTechSideNavigationMenuItem";
import { useAgTechPopUpContext } from "@agtech/core/functions/AgTechAppPopUps";

export type AgTechSideNavigationSubMenuProps = {
    text: string,
    icon: string,
    menuItems: AgTechSideNavigationMenuItemProps[],
    isCollapsed: boolean
}

const AgTechSideNavigationSubMenu = (props: AgTechSideNavigationSubMenuProps) => {
    let [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        if (props.isCollapsed) {
            setIsOpen(false);
        }
    }, [props.isCollapsed])

    let isMenuActive = props.menuItems.findIndex(mn => {
        return mn.link === window.location.pathname;
    }) >= 0;

    let isOpenClass = isOpen ? 'open' : '';
    let isActiveClass = isMenuActive && props.isCollapsed ? 'active' : '';

    return (
        <div className={`row-based flex ${isOpenClass} ${isActiveClass}`}>
            {props.isCollapsed ? (
                <AgTechPopUpOnHoverContainer
                    classes='text-addSideNavFont clickable h-[56px] w-[72px] flex'
                    popupRenderProps={() => ({
                        popup: () => <AgTechSideNavigationSubMenuPopUp {...props} />,
                        config: {
                            fadeInTime: '200ms'
                        },
                        handlers: {
                            onPopUpOpened: () => {
                                setIsOpen(true);
                            },
                            onPopUpClosed: () => {
                                setIsOpen(false);
                            }
                        }
                    })}
                    children={() => (
                        <i className={`stretched text-base text-appSideNavFont centered flex ${props.icon}`} aria-hidden="true"></i>
                    )}
                />
            ) : (
                <div
                    className='column-based items-center color-changing text-appSideNavFont hover:text-highlight-300 px-7 text-more h-[56px] cursor-pointer container'
                    onClick={() => setIsOpen(!isOpen)}
                >
                    <i className={`mr-6 !text-md ${props.icon}`} aria-hidden="true"></i>
                    {props.text}
                    <i className={`ml-auto transition-transform duration-300 !text-base fas fa-chevron-right ${isOpen ? 'transform rotate-90' : ''}`} aria-hidden="true"></i>
                </div>
            )}
            
            {props.isCollapsed ? null : (
                <div className='transition-height duration-500 overflow-hidden row-based bg-gray-600 container' style={{ height: isOpen ? (props.menuItems.length * 56) : 0 }}>
                    {props.menuItems.map(menuItem => (
                        <AgTechSideNavigationSubMenuItem
                            key={menuItem.text}
                            {...menuItem}
                        />
                    ))}
                </div>
            )}
        </div>
    )
}

export type AgTechSideNavigationSubMenuItemProps = {
    text: string,
    link: string,
    onSelected: (link: string) => void
}

const AgTechSideNavigationSubMenuItem = (props: AgTechSideNavigationSubMenuItemProps) => {
    let activeClass = window.location.pathname.endsWith(props.link) ? '!bg-highlight !text-white' : '';

    return (
        <Link
            to={`/app${props.link}`}
            className={`column-based items-center flex-1 px-7 color-changing bg-secondary text-more clickable hover:bg-highlight-600 text-white min-h-[56px] border-b first:border-t border-gray-600 container ${activeClass}}`}
            onClick={() => props.onSelected(props.link)}
        >
            {props.text}
        </Link>
    )
}


const AgTechSideNavigationSubMenuPopUp = (props: AgTechSideNavigationSubMenuProps) => {
    let popupContext = useAgTechPopUpContext();

    return (
        <div
            className='agtech-side-navigation-sub-menu-body'
            style={{
                height: props.menuItems.length * 56,
                width: 200
            }}
        >
            {props.menuItems.map(menuItem => (
                <AgTechSideNavigationMenuItem
                    key={menuItem.text}
                    {...menuItem}
                    isCollapsed={false}
                    onSelected={link => {
                        menuItem.onSelected(link);
                        
                        if (popupContext) {
                            popupContext.closePopUp();
                        }
                    }}
                />
            ))}
        </div>
    )
}

export default AgTechSideNavigationSubMenu;